// // Must be the first import
// if (process.env.NODE_ENV === 'development') {
// 	// Must use require here as import statements are only allowed
// 	// to exist at top-level.
// 	require("preact/debug");
// }

import './assets/styles/app.scss';
import { Router } from 'preact-router';
import { AppProvider } from './context/AppContext';
import { TableProvider } from './context/TableContext';
import { ToasterProvider } from './context/ToasterContext';
import Animal from './pages/Animal';
import AnimalsList from './pages/AnimalsList';
import LocationsList from './pages/LocationsList';
import Location from './pages/Location';
import FormEventMovement from './pages/FormEventMovement';
import FormEventMarker from './pages/FormEventMarker';
import FormEventOther from './pages/FormEventOther';
import FormEventWeight from './pages/FormEventWeight';
import FormEventFarrow from './pages/FormEventFarrow';
import FormEventExit from './pages/FormEventExit';
import FormAnimal from './pages/FormAnimal';
import FormLocation from './pages/FormLocation';
import FormCategory from './pages/FormCategory';
import MarkersList from './pages/MarkersList';
import EventsList from './pages/EventsList';
import EventsTypeList from './pages/EventsTypeList';
import CategoriesList from './pages/CategoriesList';
import WhoWhereWhen from './pages/WhoWhereWhen';
import Home from './pages/Home';
import Header from './components/Header';

// Config
const tableDataDefault = {
	animals: [],
	events: [],
	locations: [],
	nbResults: {
		animals:0,
		events:0,
		locations:0
	}
};
const tableActionsDefault = {
	animals: {
		selectedRows: [],
		sortedField: 'name',
		order: 'asc',
		filteredFields: {
			filtered: false,
			sex: null,
			location: null,
			markers: null
		},
		pager: {
			itemsPerPage: 2000,	
			page: 1,
		},
	},
	events: {
		selectedRows: [],
		sortedField: '',
		order: '',
		filteredFields: {
			filtered: false,
			type: null,
			category: null,
			location: null
		},
		pager: {
			itemsPerPage: 100,
			page: 1,
		}
	},
	locations: {
		selectedRows: [],
		sortedField: '',
		order: '',
		filteredFields: {
			filtered: false,
			name: null,
		},
		pager: {
			itemsPerPage: 100,
			page: 1,
		}
	}
};

// Global vars
//let isConnected=true;

if (typeof window !== "undefined") {
	window.onscroll = function() {
		// Save scroll position for all lists on load
		sessionStorage.scrollTop = document.documentElement.scrollTop;
	};
	// Eviter de perdre les states sur un refresh
	if (process.env.NODE_ENV !== 'development') {
		window.addEventListener('beforeunload', e => {
			e.preventDefault();
			e.returnValue = '';
		});
	}
}

// const getStorageQuota = async () => {
// 	console.log(navigator);
// 	if (navigator.storage) {
// 		console.log(navigator.storage)
// 	}
// 	if (navigator.storage && navigator.storage.estimate) {
// 		const quota = await navigator.storage.estimate();
// 		// quota.usage -> Number of bytes used.
// 		// quota.quota -> Maximum number of bytes available.
// 		const percentageUsed = (quota.usage / quota.quota) * 100;
// 		console.log(`You've used ${percentageUsed}% of the available storage.`);
// 		const remaining = quota.quota - quota.usage;
// 		console.log(`You can write up to ${remaining/1024/1024} more bytes.`);
// 	  }
// }

// getStorageQuota().then((res) => {
// 	//console.log(res);
// });


// const registerServiceWorker = async () => {
// 	if ('serviceWorker' in navigator) {
// 		try {
// 			const registration = await navigator.serviceWorker.register(
// 				'/sw.js',
// 				{
// 					scope: '/',
// 				}
// 			);
// 			if (registration.installing) {
// 				console.log('Service worker installing');
// 			} else if (registration.waiting) {
// 				console.log('Service worker installed');
// 			} else if (registration.active) {
// 				console.log('Service worker active');
// 			}
// 		} catch (error) {
// 			console.error(`Registration failed with ${error}`);
// 		}
// 	}
// 	else console.log('no service worker');
// };

// registerServiceWorker();

const App = () => (
	<ToasterProvider>
		<TableProvider tableDataDefault={tableDataDefault} tableActionsDefault={tableActionsDefault}>
			<AppProvider>
				<div class="mt-5">
					<Header />
					<Router>
						<Home path="/" />
						<Home path="/home" />
						<AnimalsList path="/animals" />
						<Animal path="/animal/:id" />
						<FormAnimal path="/form-animal/:id?" />
						<FormAnimal path="/form-animal/birth/mother/:mother_id/nob/:nob/bnum/:bnum/date/:date" />
						<LocationsList path="/locations" />
						<Location path="/location/:id" />
						<FormLocation path="/form-location/:id?" />
						<MarkersList path="/markers" />
						<EventsList path="/history" />
						<EventsTypeList path="/events-type-list" />
						<FormEventMarker path="/event-marker/:id?" />
						<FormEventMarker path="/event-marker/animal/:animal_id" />
						<FormEventMovement path="/event-movement/:id?" />
						<FormEventMovement path="/event-movement/animal/:animal_id" />
						<FormEventWeight path="/event-weight/:id?" />
						<FormEventWeight path="/event-weight/animal/:animal_id" />
						<FormEventOther path="/event-other/:id?" />
						<FormEventOther path="/event-other/animal/:animal_id" />
						<FormEventOther path="/event-other/type/:type_id" />
						<FormEventOther path="/event-other/type/:type_id/animal/:animal_id" />
						<FormEventOther path="/event-type/:edit_type_id?" />
						<FormEventFarrow path="/event-farrow/:id?" />
						<FormEventFarrow path="/event-farrow/animal/:animal_id" />
						<FormEventExit path="/event-exit/:id?" />
						<FormEventExit path="/event-exit/animal/:animal_id" />
						<CategoriesList path="/categories" />
						<WhoWhereWhen path="/whowherewhen" />
						<FormCategory path="/form-category/:id?" />
					</Router>
				</div>
			</AppProvider>
		</TableProvider>
	</ToasterProvider>
);

export default App;
